import axiosTokenInstance from "services/api/backoffice";
import { GET_EMAIL_REPORT, GET_EMAIL_REPORT_ERROR } from "_models/redux/types";

// Action function
export const getEmailReportAction = (params) => async (dispatch) => {
    const { from_time, to_time, min_ocurrences } = params || {};

    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/reports/prevention/email-report?from_time=${from_time}&to_time=${to_time}&min_ocurrences=${min_ocurrences}`
        );

        const { data, status } = response || {};

        dispatch({
            method: "get",
            payload: data || {},
            status: status || {},
            type: GET_EMAIL_REPORT,
        });
    } catch (e) {
        const { response } = e || {};
        const { status } = response || {};

        dispatch({
            method: "get",
            payload: e || {},
            status: status,
            type: GET_EMAIL_REPORT_ERROR,
        });
    }
};
